import React from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaCut, FaAward, FaShieldAlt, FaLeaf, FaArrowRight } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import heroBanner from '../../assets/images/hero/tspc-banner.png';
import './Home.css';

const services = [
  { icon:<FaCut />, title:'Cutting Process', desc:'Stainless steel material cut into specifications as simple straight cuts with precision equipment.', link:'/cutting-process' },
  { icon:<FaCogs />, title:'Escomatic Process', desc:'Small diameter parts with designs like chamfer, spherical radius, groove and straight end cut.', link:'/escomatic-process' },
  { icon:<FaAward />, title:'Quality Assurance', desc:'Advanced QA equipment ensuring every shaft meets the tightest customer specification requirements.', link:'/quality-assurance' },
];

const Home = () => (
  <div className="home">
    <Hero
      title={<>Connecting Your <span className="highlight">Innovations</span></>}
      subtitle="Tokyo Steel Philippines Corporation — manufacturer of ultra precise stainless steel shafts. ISO Certified since 2007."
      backgroundImage={heroBanner}
      showCta ctaText="View Products" ctaLink="/products"
    />

    <section className="home__about section">
      <div className="container">
        <p className="section-label">About Us</p>
        <h2 className="section-title">Ultra Precise <span className="highlight">Stainless Steel</span> Shafts</h2>
        <p className="home__about-text">
          Tokyo Steel is one of the first manufacturers of ultra precise stainless steel shafts in the Philippines.
          Established on March 25, 1997, we are a proud ISO Certified company since 2007, delivering
          precision-engineered components to industries worldwide.
        </p>
        <div className="home__stats">
          <div className="stat-card"><span className="stat-card__number">1997</span><span className="stat-card__label">Established</span></div>
          <div className="stat-card"><span className="stat-card__number">2007</span><span className="stat-card__label">ISO Certified</span></div>
          <div className="stat-card"><span className="stat-card__number">20+</span><span className="stat-card__label">Global Locations</span></div>
          <div className="stat-card"><span className="stat-card__number">14</span><span className="stat-card__label">Countries</span></div>
        </div>
      </div>
    </section>

    <section className="home__services section">
      <div className="container">
        <p className="section-label">Our Processes</p>
        <h2 className="section-title">Manufacturing <span className="highlight">Excellence</span></h2>
        <div className="home__services-grid">
          {services.map((s, i) => (
            <Link to={s.link} className="service-card" key={i}>
              <div className="service-card__icon">{s.icon}</div>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__desc">{s.desc}</p>
              <span className="service-card__link">Learn More <FaArrowRight /></span>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <section className="home__policy section">
      <div className="container">
        <div className="home__policy-grid">
          <div className="policy-card">
            <div className="policy-card__icon"><FaShieldAlt /></div>
            <h3>Quality Policy</h3>
            <p>Continually improving our products and services, effectively utilizing our available resources, and consistently complying with quality requirements.</p>
          </div>
          <div className="policy-card">
            <div className="policy-card__icon"><FaLeaf /></div>
            <h3>Environmental Policy</h3>
            <p>Effectively managing environmental hazards to protect the environment, prevent pollution, and comply with environmental requirements including prohibited chemical substances.</p>
          </div>
        </div>
        <p className="home__policy-note">"This endeavour will be constantly communicated with our employees to ensure that this becomes TSPC's way of life."</p>
      </div>
    </section>
  </div>
);

export default Home;
